var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1706 1.28718C9.07764 1.19398 8.9672 1.12004 8.84562 1.06959C8.72403 1.01913 8.59369 0.993164 8.46205 0.993164C8.33041 0.993164 8.20007 1.01913 8.07849 1.06959C7.9569 1.12004 7.84647 1.19398 7.7535 1.28718L1.10035 7.94033C1.02613 8.0144 0.967244 8.10238 0.927067 8.19923C0.886891 8.29609 0.866211 8.39991 0.866211 8.50477C0.866211 8.60962 0.886891 8.71345 0.927067 8.8103C0.967244 8.90716 1.02613 8.99514 1.10035 9.06921L7.7535 15.7224C8.14581 16.1147 8.7783 16.1147 9.1706 15.7224C9.5629 15.3301 9.5629 14.6976 9.1706 14.3053L3.37411 8.50077L9.17861 2.69627C9.5629 2.31197 9.5629 1.67148 9.1706 1.28718Z",
    fill: "#858585"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.a793448bfc6abdcf43c47cd201105de2.svg";
export { ForwardRef as ReactComponent };